module.exports = __webpack_public_path__ + "static/media/Food9.5cca426f.jpg";